import Glide from '@glidejs/glide';
import { adjustHeight, getNextSlide } from '../helpers';
import { breakpoints } from '../../../variables';
import loadedModules from "../../../loadedModules";
import Helpers from '../../../helpers';

$(document).ready(() => {
    const template = $( '.js-fond-integration-need-help--template' );
    const container = $( '.js-fond-integration-need-help' );
    const items_container = container.find('.hh-need-help__slides');

    const arrowLeft = container.find('.hh-slider-arrows__left-arrow');
    const arrowRight = container.find('.hh-slider-arrows__right-arrow');

    if ( !container.length ) {
        return;
    }

    const items = HH.fond_integration_need_help__json_data;

    // Mustache render
    const renderTemplate = function (data) {
        const render_result = Mustache.render( template.html(), { items: data } );
        items_container.html(render_result);
    };

    const initSlider = () => {
        const sliderContainerClass = '.hh-need-help__glide';

        const glideSlider = new Glide(sliderContainerClass, {
            perView: 2,
            type: 'carousel',
            gap: 24,
            breakpoints: {
                [breakpoints.mobile]: {
                    perView: 1,
                }
            },
        });

        glideSlider.on('build.after', () => {
            if ($(window).outerWidth() <= breakpoints.mobile) {
                $('.hh-need-help .glide__slide--active img').on('load', () => {
                    adjustHeight($('.hh-need-help .glide__slide--active'));
                })
            }
        });

        $(window).resize(() => {
            adjustHeight($('.hh-need-help .glide__slide--active'));
        });

        glideSlider.on('run.before', (move) => {
            if ($(window).outerWidth() <= breakpoints.mobile) {
                const nextSlide = getNextSlide(sliderContainerClass, glideSlider.index, move.direction);
                adjustHeight(nextSlide);
            }
        });

        if ($(glideSlider.selector).find('.glide__slide').length) {
            return glideSlider.mount();
        }
    }

    const clickArrowsAction = (sliderObject, $arrowLeft, $arrowRight) => {
        $arrowLeft.click(() => {
            sliderObject.go('<');
        });
        $arrowRight.click(() => {
            sliderObject.go('>');
        });
    }

    renderTemplate(Helpers.shuffle(items).slice(0, 10));
    const slider = initSlider();
    clickArrowsAction(slider, arrowLeft, arrowRight);
    loadedModules.clampLoading();
});